import { useState, useContext, useEffect } from "react";
import SetUserCard from "./setusercard";
import styles from "./styles.module.css";
import { functions } from "../../firebase";
import { UserValue } from "../../contexts/user";
import { LoaderDisbatch } from "../../contexts/loader";
import { Select, Option } from "../../select";
const subscribeAppToPlan = functions.httpsCallable("subscribeAppToPlan");
const plans = [
  {
    id: "free",
    name: "Free",
    price: 0,
  },
  {
    id: "launch",
    name: "Launch",
    price: 39,
  },
];

export default function AppPlan({ plan, appId, members }) {
  const user = useContext(UserValue);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [_plan, setPlan] = useState({});
  const setLoader = useContext(LoaderDisbatch);

  useEffect(() => {
    const _plan = plans.find((x) => x.id === plan);
    setPlan(_plan);
  }, [plan]);

  const handlePlanSelect = async (v) => {
    const plan = plans.find((x) => x.id === v);
    setPlan(plan);
  };

  const subscribe = async () => {
    setLoader(true);
    try {
      await subscribeAppToPlan({ plan: _plan.id, appId });
      setError("");
    } catch (err) {
      console.log(err);
      setError(
        "We had an issue trying to upgrade your plan. Plase contact us and we'll get it fixed!"
      );
    }
    setLoader(false);
  };

  const handlePlanChange = async () => {
    if (
      user.billing &&
      user.billing.paymentMethod &&
      user.billing.paymentMethod.id
    ) {
      subscribe();
    } else {
      setOpen(true);
    }
  };

  if (!(user && members[user.id] && members[user.id].role === "owner")) {
    return (
      <div className={styles.appPlan}>
        <div className={styles.cardTitle}>
          Only the owner of the application can update the app plan
        </div>
      </div>
    );
  }

  return (
    <div className={styles.paper}>
      <div className={styles.subtitle}>App Plan</div>
      <Select onChange={handlePlanSelect} value={_plan.id}>
        {plans.map((p) => {
          return (
            <Option key={p.id} value={p.id}>
              {p.name}
            </Option>
          );
        })}
      </Select>

      {plan !== _plan.id && (
        <div>
          {error && <div className={styles.errorText}>{error}</div>}
          <div className={styles.bodytext}>
            Price - <span>${_plan.price}</span>
          </div>
          <button onClick={handlePlanChange} className={styles.cardButton}>
            Change Plan
          </button>
          <div className={styles.helpText}>
            For more info on plans{" "}
            <a
              href="https://www.notion.so/brevity/Brevity-Pricing-Plans-91fb4c2bc9934b239b180992465beee8"
              className={styles.clickHere}
            >
              click here
            </a>
          </div>
        </div>
      )}
      <SetUserCard
        onSuccess={() => {
          setOpen(false);
        }}
        onError={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        open={open}
      />
    </div>
  );
}
